import type { ReactElement } from 'react'

interface SearchSpinnerProps {
    readonly size?: 'sm' | 'lg'
    readonly overlay?: boolean
}

export function SearchSpinner({ size = 'sm', overlay = false }: SearchSpinnerProps): ReactElement {
    const spinnerSizeClass = size === 'lg' ? 'h-12 w-12' : 'h-4 w-4'

    if (overlay) {
        return (
            <span className='pointer-events-none absolute inset-0 flex items-center justify-center bg-slate-950/80 text-slate-300'>
                <span className='flex flex-col items-center gap-2'>
                    <svg
                        className={`${spinnerSizeClass} animate-spin text-sky-300`}
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        aria-hidden='true'
                    >
                        <circle
                            className='opacity-25'
                            cx='12'
                            cy='12'
                            r='10'
                            stroke='currentColor'
                            strokeWidth='4'
                        />
                        <path
                            className='opacity-75'
                            fill='currentColor'
                            d='M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z'
                        />
                    </svg>
                    <span className='text-xs font-medium tracking-wide uppercase'>
                        Searching Converse Catalog…
                    </span>
                </span>
            </span>
        )
    }

    return (
        <span className='absolute inset-y-0 right-3 flex items-center text-xs text-slate-400'>
            <svg
                className={`${spinnerSizeClass} animate-spin text-sky-300`}
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                aria-hidden='true'
            >
                <circle
                    className='opacity-25'
                    cx='12'
                    cy='12'
                    r='10'
                    stroke='currentColor'
                    strokeWidth='4'
                />
                <path
                    className='opacity-75'
                    fill='currentColor'
                    d='M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z'
                />
            </svg>
        </span>
    )
}

export default SearchSpinner
